import React from 'react';
import { useQuery } from 'react-query';
import { fetchLastAttemptsForExperts } from '../api';
import {
  useStatContextStore,
  apiStatContextSelector,
  StatContextState,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import { shallow } from 'zustand/shallow';
import { UserChatBulkAuditModal } from 'react-scale/components/ExpertManagement/ExpertManagementPage/BulkAudit/UserChatBulkAuditModal';

const selectors = (state: StatContextState) => ({
  apiStatContext: apiStatContextSelector(state),
});

export interface ExpertInfo {
  id: string;
  name: string;
}

export const UsersChatBulkAuditModal: React.FC<{
  onClose: () => void;
  experts: ExpertInfo[];
  isOpen: boolean;
}> = ({ onClose, experts, isOpen }) => {
  const { apiStatContext } = useStatContextStore(selectors, shallow);
  const expertIds = experts.map(e => e.id);
  const { data, isLoading: loading } = useQuery(
    [`lastAttemptsForExperts`, ...expertIds, `${isOpen}`],
    () => {
      if (expertIds.length && isOpen)
        return fetchLastAttemptsForExperts(
          apiStatContext,
          experts.map(e => e.id),
        );
      else return Promise.resolve(null);
    },
    {
      staleTime: 60 * 1000,
    },
  );
  const tasks = data?.tasks ?? [];

  return (
    <div>
      <UserChatBulkAuditModal
        isOpen={isOpen}
        onClose={onClose}
        tasks={tasks}
        loadingTasks={loading}
        experts={experts}
      />
    </div>
  );
};
